import { useEffect, useState } from "react";
import DropdownField, { dropdownProps, DropdownOptions } from "./DropdownField";
import { getDynamicDropdownByCategory } from "../../views/Admin/DynamicDropdowns/manageDynamicDropdowns";
import Loading from "../Loading/Loading";

interface DynamicDropdownFieldProps extends Omit<dropdownProps, "options"> {
  category: string;
}

const DynamicDropdownField = ({
  category,
  ...rest
}: DynamicDropdownFieldProps) => {
  const [options, setOptions] = useState<DropdownOptions[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!category) return;
    setLoading(true);
    getDynamicDropdownByCategory(category)
      .then((res) => {
        if (res.status === 200) {
          const dropdowns: DropdownOptions[] = res.data.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          setOptions(dropdowns);
        }
      })
      .finally(() => setLoading(false));
  }, [category]);

  if (loading) return <Loading showLogo={false} fullScreen={false} />;

  return (
    <DropdownField
      options={options}
      placeholder={rest.placeholder || category}
      {...rest}
    />
  );
};

export default DynamicDropdownField;
